import {TimeframeMethods} from "./timeframe";
import { EngagementOracleMethods as UserEngagementMethods } from "./user-engagement";


export const OracleMethods = {
  ...TimeframeMethods,
  ...UserEngagementMethods,
};

export default OracleMethods;